"use strict";

import { contact } from "../animations";

const mainNav = document.querySelector(".nav__main");
const secNav = document.querySelector(".nav__sec p");

const handler = () => navReusables.toggleNav();

export const navReusables = {
	toggleNav: function (action = "both") {
		switch (action) {
			case "both":
				secNav.parentElement.classList.toggle("hide");
				mainNav.classList.toggle("hide");
				break;
			case "main":
				mainNav.classList.toggle("hide");
				break;
			case "sec":
				secNav.parentElement.classList.toggle("hide");
		}
	},
	addRemoveClass: function (nav, action) {
		switch (nav) {
			case "main":
				if (action === "add") mainNav.classList.add("hide");
				else if (action === "remove") mainNav.classList.remove("hide");
				break;
			case "sec":
				if (action === "add") mainNav.classList.add("hide");
				else if (action === "remove") mainNav.classList.remove("hide");
				break;
		}
	},
	mainListener: function (type) {
		switch (type) {
			case "add":
				mainNav.addEventListener("mouseleave", handler);
				break;
			case "remove":
				mainNav.removeEventListener("mouseleave", handler);
		}
	},
	secListener: function (type) {
		switch (type) {
			case "add":
				secNav.addEventListener("mouseover", handler);
				break;
			case "remove":
				secNav.removeEventListener("mouseover", handler);
		}
	},
};

export const nav = function () {
	const contactBtn = document.querySelector("#contact");
	const closeIcon = document.querySelector("#close");
	const copy = document.querySelector("#copy");
	const email = document.querySelector(".email h4");
	const alert = document.querySelector(".alert");

	navReusables.mainListener("remove");

	const showAlert = function (str) {
		alert.textContent = str;
		alert.classList.add("show");

		setTimeout(() => {
			alert.classList.remove("show");
		}, 3000);
	};

	contactBtn.addEventListener("click", () => {
		contact(true);
	});

	closeIcon.addEventListener("click", () => {
		contact(false);
	});

	copy.addEventListener("click", async (e) => {
		const text = email.textContent.trim();

		if (
			typeof navigator !== "undefined" &&
			typeof navigator.clipboard !== "undefined" &&
			navigator.permissions !== "undefined"
		) {
			await navigator.clipboard.writeText(text);
			showAlert("Email has been successfully copied to your clipboard");
		} else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
			const tempInput = document.createElement("input");
			tempInput.setAttribute("value", text);
			copy.parentNode.append(tempInput);
			tempInput.select();
			document.execCommand("copy");
			copy.parentNode.removeChild(tempInput);
			showAlert("Email has been successfully copied to your clipboard");
		}
	});
};
